export const currencyToCountry = {
  CHF: "CH",
  DKK: "DK",
  GBP: "GB",
  HKD: "HK",
  JPY: "JP",
  NOK: "NO",
  NZD: "NZ",
  SEK: "SE",
  SGD: "SG",
  ZAR: "ZA"
} as const;
